/**
 * Check if user has a specific permission
 * @param {string} key - Permission key to check
 * @returns {boolean} - True if user has permission
 */
export function hasPermission(key) {
  try {
    const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
    return permissions.includes(key);
  } catch (error) {
    console.error("Error reading permissions:", error);
    return false;
  }
}

/**
 * Get all user permissions
 * @returns {string[]} - Array of permission keys
 */
export function getPermissions() {
  try {
    return JSON.parse(sessionStorage.getItem("permissions") || "[]");
  } catch (error) {
    console.error("Error reading permissions:", error);
    return [];
  }
}

/**
 * Set user permissions
 * @param {string[]} permissions - Array of permission keys
 */
export function setPermissions(permissions) {
  try {
    sessionStorage.setItem("permissions", JSON.stringify(permissions));
  } catch (error) {
    console.error("Error setting permissions:", error);
  }
}

/**
 * Clear permissions (on logout)
 */
export function clearPermissions() {
  try {
    sessionStorage.removeItem("permissions");
  } catch (error) {
    console.error("Error clearing permissions:", error);
  }
}

